import axios, { AxiosResponse } from 'axios';
import internalAPI, { handleInternalAPIError } from './internalAPI';

/**
 * Updates the user.
 *
 * @param values to update user profile
 * @returns
 */
export const updateUser = async (values: any) => {
  // Attempt to refresh the token
  const response = await internalAPI(true)
    .put('/api/user', {
      ...values
    })
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    return { success: true, status: response.status };
  }
  return { success: false, status: response.status };
};

/**
 * Updates the user with a patch request.
 *
 * @param values to update user profile
 * @returns
 */
export const patchUser = async (values: any) => {
  const response = await internalAPI(true)
    .patch('/api/user', {
      ...values
    })
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    return { success: true, status: response.status, data: response.data };
  } else {
    return { success: false, status: response.status, data: {} };
  }
};

/**
 * Gets user profile details.
 * @returns
 */
export const getUser = async () => {
  // Attempt to refresh the token
  const response = await internalAPI(true)
    .get('/api/user', {
      validateStatus: function (status: number) {
        return status == 200 || status == 401;
      }
    })
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    return {
      success: true,
      user: response.data.profile,
      status: response.status
    };
  }

  return { success: false, user: {}, status: response.status };
};

/**
 * Delete user.
 * @returns
 */
export const deleteUser = async (values: any) => {
  const response = await internalAPI(true)
    .delete('/api/user', {
      data: {
        values
      }
    })
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    // return response;
    return { success: true, status: response.status };
  }

  return { success: false, status: response.status };
};

/**
 * Get user file.
 * @returns
 */
export const getUserFile = async (id) => {
  const response = await internalAPI(true)
    .get('/api/file/' + id)
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    return { success: true, data: response.data.file };
  }

  return { success: true, status: response.status, data: {} };
};

/**
 * Applies a users to an opportunity
 *
 * @param values credentials
 * @return
 */
export const applyByEmail = async (values: any, job: any) => {
  if (!values.email) {
    return false;
  }

  const response = await internalAPI(true)
    .post('/api/apply-by-email', {
      job: job,
      ...values
    })
    .catch((error) => {
      return handleInternalAPIError(error);
    });

  if (response.status == 200) {
    return { success: true, status: response.status, data: response.data };
  }

  return { success: false, status: response.status, data: {} };
};

/**
 * Get auth url for starting oauth connect redirection process
 * @param data
 * @return
 */
export const oauthConnect = async (data: any) => {
  const response: AxiosResponse = await axios.post(
    '/oauth/connect/' + data.provider,
    {
      host: `users.${process.env.GATSBY_TOKEN_HOST}`,
      lastAction: data.lastAction ? data.lastAction : null
    },
    {
      validateStatus: (status) => {
        return status == 200 || status == 401;
      }
    }
  );
  return {
    status: response.status,
    data: response.data
  };
};
